export const getFileNameAndExtension = (filename: string) => {
  const fileExtension = filename?.split('.').pop();
  const fileName = filename?.replace(`.${fileExtension}`, '');

  return {
    fileName,
    fileExtension,
  };
};
